export default __webpack_public_path__ + "static/media/k-image.1643d00e.png";